(function(){
  var I18N = {
    en: {
      nav_home: 'Home', nav_mixes: 'Mixes & Blends', nav_pickles: 'Pickles', nav_labneh: 'With Labneh',
      nav_faq: 'FAQ', nav_policy: 'Shipping & Returns', search_placeholder: 'Search for a product...',
      badge_natural: '100% Natural', badge_free_ship: 'Free shipping over', badge_homemade: 'Authentic homemade recipes',
      hero_cta: 'Our Products', cat_all: 'All', cat_mixes: 'Mixes & Blends', cat_pickles: 'Pickles', cat_labneh: 'With Labneh',
      cart_title: 'Shopping Cart', ship_add: 'Add', ship_aed: 'AED', ship_get_free: 'to get free shipping',
      ship_free_done: 'Congrats! Free shipping on your order', cart_empty: 'Your cart is empty', cart_browse: 'Browse Products',
      cart_subtotal: 'Subtotal', cart_total_shipping: 'Total (shipping calculated at checkout)', cart_total_free: 'Total (free shipping)',
      cart_checkout: 'Checkout', cart_upsell: 'You might also like', badge_bestseller: 'Best Seller',
      pkg_title: 'Choose your package', pkg_bestseller: 'Most Popular', qty_label: 'Quantity:', add_to_cart: 'Add to Cart',
      reviews_title: 'Customer Reviews', related_title: 'Related Products',
      footer_links: 'Quick Links', footer_shop: 'Shop', footer_contact: 'Contact Us', footer_whatsapp: 'WhatsApp',
      footer_instagram: 'Instagram', footer_rights: 'All rights reserved',
      '404_title': '404 - Page Not Found', '404_desc': 'The page you are looking for does not exist or has been moved.', '404_back': 'Back to Home'
    },
    ar: {
      nav_home: 'الرئيسية', nav_mixes: 'مكسات وخلطات', nav_pickles: 'مخللات', nav_labneh: 'منتجات مع لبنة',
      nav_faq: 'الأسئلة الشائعة', nav_policy: 'الشحن والإرجاع', search_placeholder: 'دور على منتج...',
      badge_natural: 'طبيعي 100%', badge_free_ship: 'توصيل مجاني فوق', badge_homemade: 'وصفات بيتية أصيلة',
      hero_cta: 'منتجاتنا', cat_all: 'الكل', cat_mixes: 'مكسات وخلطات', cat_pickles: 'مخللات', cat_labneh: 'منتجات مع لبنة',
      cart_title: 'سلة التسوق', ship_add: 'اضف', ship_aed: 'درهم', ship_get_free: 'للحصول على توصيل مجاني',
      ship_free_done: 'مبروك! التوصيل مجاني على طلبك', cart_empty: 'السلة فاضية لهلق', cart_browse: 'تصفّح المنتجات',
      cart_subtotal: 'المجموع الفرعي', cart_total_shipping: 'الإجمالي (الشحن يُحسب عند الدفع)', cart_total_free: 'الإجمالي (التوصيل مجاني)',
      cart_checkout: 'إتمام الطلب', cart_upsell: 'منتجات قد تعجبك', badge_bestseller: 'الأكثر مبيعاً',
      pkg_title: 'اختر الباقة المناسبة', pkg_bestseller: 'الأكثر طلباً', qty_label: 'الكمية:', add_to_cart: 'إضافة',
      reviews_title: 'تقييمات الزبائن', related_title: 'منتجات ذات صلة',
      footer_links: 'روابط سريعة', footer_shop: 'المتجر', footer_contact: 'تواصل معنا', footer_whatsapp: 'واتساب',
      footer_instagram: 'إنستغرام', footer_rights: 'جميع الحقوق محفوظة',
      '404_title': '404 - الصفحة مش موجودة', '404_desc': 'الصفحة يلي بتدور عليها مش موجودة أو تم نقلها.', '404_back': 'رجوع للرئيسية'
    }
  };

  var PRODUCT_NAMES = {
    'خلطة اللبنة مع الزيتون': 'Labneh & Olives Mix',
    'خلطة اللبنة مع المكدوس': 'Labneh & Makdous Mix',
    'خلطة لبنة + زيتون': 'Labneh & Olives Mix',
    'خلطة لبنة + مكدوس مقطع': 'Labneh & Makdous Mix',
    'خلطة لبنة ريفي': 'Ultimate reefi Mix',
    'خلطة لبنة ريفي السياسي': 'Spicy reefi Mix',
    'زيتون محشي لبنة': 'Stuffed Olives',
    'مخلل خيار': 'Pickled Cucumber',
    'مخلل زهرة': 'Cauliflower',
    'مخلل فلفل': 'Pickled Pepper',
    'مخلل فلفل عادي': 'Pickled Pepper',
    'مخلل فلفل أحمر': 'Red Pepper',
    'مخلل فلفل محشي لبنة': 'Stuffed Chili',
    'مخلل لفت': 'Turnips',
    'مكدوس': 'Makdous',
    'مكدوس محشي لبنة': 'Stuffed Makdous',
    'ورق عنب محشي لبنة': 'Grape Leaves'
  };

  var CATEGORY_KEY = {
    'مكسات وخلطات': 'cat_mixes',
    'مخللات': 'cat_pickles',
    'منتجات مع لبنة': 'cat_labneh'
  };

  var VARIANT_NAMES = {
    'علبة وحدة': 'Single Box',
    'باقة تجربة (علبتين)': 'Trial Pack (2 Boxes)',
    'باقة العيلة (4 علب)': 'Family Pack (4 Boxes)'
  };

  var VARIANT_DISPLAY = {
    'علبة وحدة': { ar: { main: 'علبة', sub: '' }, en: { main: 'Box', sub: '' } },
    'باقة تجربة (علبتين)': { ar: { main: 'باقة', sub: ' علبتين' }, en: { main: 'Trial Pack', sub: ' (2 Boxes)' } },
    'باقة العيلة (4 علب)': { ar: { main: 'باقة العيلة', sub: ' (4 علب)' }, en: { main: 'Family Pack', sub: ' (4 Boxes)' } }
  };

  function applyPkgVariantDisplay(lang){
    document.querySelectorAll('.pkg-name[data-variant-title]').forEach(function(el){
      var key = el.getAttribute('data-variant-title');
      var d = VARIANT_DISPLAY[key];
      if(!d) return;
      var t = d[lang] || d.ar;
      var mainEl = el.querySelector('.pkg-name-main');
      var subEl = el.querySelector('.pkg-name-sub');
      if(mainEl) mainEl.textContent = t.main;
      if(subEl) subEl.textContent = t.sub;
    });
  }

  var currentLang = 'ar';

  function applyProductTranslations(lang){
    document.querySelectorAll('.product-title-text').forEach(function(el){
      if(el.dataset.ar === undefined) el.dataset.ar = el.textContent.trim();
      var ar = el.dataset.ar;
      el.textContent = (lang === 'en' && PRODUCT_NAMES[ar]) ? PRODUCT_NAMES[ar] : ar;
    });
    document.querySelectorAll('.card-cat').forEach(function(el){
      if(el.dataset.ar === undefined) el.dataset.ar = el.textContent.trim();
      var ar = el.dataset.ar;
      var key = CATEGORY_KEY[ar];
      el.textContent = (lang === 'en' && key && I18N.en[key]) ? I18N.en[key] : ar;
    });
    document.querySelectorAll('.variant-title-text').forEach(function(el){
      if(el.dataset.ar === undefined) el.dataset.ar = el.textContent.trim();
      var ar = el.dataset.ar;
      el.textContent = (lang === 'en' && VARIANT_NAMES[ar]) ? VARIANT_NAMES[ar] : ar;
    });
  }

  function applyLanguage(lang){
    if(lang !== 'en' && lang !== 'ar') lang = 'ar';
    currentLang = lang;
    var dict = I18N[lang];
    document.documentElement.setAttribute('lang', lang);
    document.documentElement.setAttribute('dir', lang === 'en' ? 'ltr' : 'rtl');
    document.querySelectorAll('[data-i18n]').forEach(function(el){
      var key = el.getAttribute('data-i18n');
      if(dict[key] !== undefined) el.textContent = dict[key];
    });
    document.querySelectorAll('[data-i18n-placeholder]').forEach(function(el){
      var key = el.getAttribute('data-i18n-placeholder');
      if(dict[key] !== undefined) el.placeholder = dict[key];
    });
    document.querySelectorAll('.lang-btn').forEach(function(btn){
      btn.classList.toggle('active', btn.dataset.lang === lang);
    });
    applyProductTranslations(lang);
    applyPkgVariantDisplay(lang);
    try { localStorage.setItem('reefi_lang', lang); } catch(e){}
  }

  function initLanguage(){
    var saved = 'ar';
    try { saved = localStorage.getItem('reefi_lang') || 'ar'; } catch(e){}
    applyLanguage(saved);
    var switcher = document.getElementById('langSwitch');
    if(switcher){
      switcher.addEventListener('click', function(e){
        var btn = e.target.closest('.lang-btn');
        if(btn) applyLanguage(btn.dataset.lang);
      });
    }
  }

  function toast(msg){
    var t = document.getElementById('toast');
    if(!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(window._toastTimer);
    window._toastTimer = setTimeout(function(){ t.classList.remove('show'); }, 2200);
  }

  function setHeaderHeightVar(){
    var header = document.querySelector('header.site-header');
    if(!header) return;
    document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');
  }

  function updateCartCount(){
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
      var el = document.getElementById('cartCount');
      if(el) el.textContent = cart.item_count;
    }).catch(function(){});
  }

  function refreshCartPage(){
    // if we're on the cart page, re-fetch it and swap in the fresh markup instead of a full reload
    if(!document.querySelector('.cart-wrap')) return;
    fetch(window.location.pathname + window.location.search)
      .then(function(r){ return r.text(); })
      .then(function(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newWrap = doc.querySelector('.cart-wrap');
        var oldWrap = document.querySelector('.cart-wrap');
        if(newWrap && oldWrap){
          oldWrap.innerHTML = newWrap.innerHTML;
          syncCardQuantities();
          applyProductTranslations(currentLang);
        }
      }).catch(function(){});
  }

  function syncCardQuantities(){
    var steppers = document.querySelectorAll('.card-qty-stepper');
    if(!steppers.length) return;
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
      var qtyMap = {};
      cart.items.forEach(function(item){ qtyMap[item.variant_id] = item.quantity; });
      steppers.forEach(function(stepper){
        var vid = stepper.dataset.variantId;
        var qty = qtyMap[vid] || 0;
        var valEl = stepper.querySelector('.card-qty-val');
        if(valEl) valEl.textContent = qty;
        stepper.classList.toggle('has-qty', qty > 0);
      });
    }).catch(function(){});
  }

  function flyToCart(originEl){
    var cartLink = document.querySelector('a.icon-btn');
    if(!originEl || !cartLink) return;
    var startRect = originEl.getBoundingClientRect();
    var endRect = cartLink.getBoundingClientRect();

    var clone = originEl.cloneNode(true);
    clone.classList.add('fly-cart-clone');
    clone.style.top = startRect.top + 'px';
    clone.style.left = startRect.left + 'px';
    clone.style.width = startRect.width + 'px';
    clone.style.height = startRect.height + 'px';
    clone.style.margin = '0';
    document.body.appendChild(clone);

    // force reflow so the browser registers the start position before we animate
    clone.getBoundingClientRect();

    var endLeft = endRect.left + endRect.width / 2 - 14;
    var endTop = endRect.top + endRect.height / 2 - 14;

    requestAnimationFrame(function(){
      clone.style.top = endTop + 'px';
      clone.style.left = endLeft + 'px';
      clone.style.width = '28px';
      clone.style.height = '28px';
      clone.classList.add('fly-active');
    });

    setTimeout(function(){
      clone.remove();
      cartLink.classList.add('cart-bump');
      setTimeout(function(){ cartLink.classList.remove('cart-bump'); }, 400);
    }, 680);
  }

  function changeCardQty(stepper, newQty, oldQty){
    var vid = stepper.dataset.variantId;
    if(!vid) return;
    var valEl = stepper.querySelector('.card-qty-val');
    if(valEl) valEl.textContent = newQty;
    stepper.classList.toggle('has-qty', newQty > 0);
    stepper.classList.add('loading');

    if(oldQty === 0 && newQty > 0){
      var cardEl = stepper.closest('.card');
      if(cardEl) flyToCart(cardEl);
    }

    var request;
    if(oldQty === 0 && newQty > 0){
      request = fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: vid, quantity: newQty }] })
      });
    } else {
      request = fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: vid, quantity: newQty })
      });
    }

    request.then(function(r){
      if(!r.ok) throw new Error('cart update failed');
      return r.json();
    }).then(function(){
      stepper.classList.remove('loading');
      updateCartCount();
      refreshCartPage();
    }).catch(function(){
      stepper.classList.remove('loading');
      toast('في مشكلة، جرب كمان مرة');
      syncCardQuantities();
    });
  }

  function removeCartLine(line, rowEl){
    if(!rowEl){
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: 0 })
      }).then(function(){ updateCartCount(); refreshCartPage(); });
      return;
    }
    var rect = rowEl.getBoundingClientRect();
    rowEl.style.height = rect.height + 'px';
    rowEl.getBoundingClientRect(); // force reflow so the fixed height is committed before collapsing
    rowEl.classList.add('removing');
    setTimeout(function(){
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: 0 })
      }).then(function(){
        updateCartCount();
        refreshCartPage();
      }).catch(function(){
        toast('في مشكلة، جرب كمان مرة');
        refreshCartPage();
      });
    }, 520);
  }

  function updateCartLine(line, newQty){
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: newQty })
    }).then(function(){
      updateCartCount();
      refreshCartPage();
    }).catch(function(){
      toast('في مشكلة، جرب كمان مرة');
    });
  }

  function quickAdd(variantId, btn){
    if(!variantId) return;
    var original = btn.textContent;
    btn.textContent = '...';
    var cardEl = btn.closest('.card');
    if(cardEl) flyToCart(cardEl);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    }).then(function(r){
      if(!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function(){
      updateCartCount();
      toast('تمت الإضافة للسلة');
      btn.textContent = 'أضيفت';
      btn.classList.add('added');
      clearTimeout(btn._addedTimer);
      btn._addedTimer = setTimeout(function(){
        btn.textContent = original;
        btn.classList.remove('added');
      }, 1600);
    }).catch(function(){
      toast('في مشكلة، جرب كمان مرة');
      btn.textContent = original;
    });
  }

  document.addEventListener('click', function(e){
    var quickBtn = e.target.closest('.quick-add');
    if(quickBtn){
      e.preventDefault();
      quickAdd(quickBtn.dataset.variantId, quickBtn);
      return;
    }

    var faqQ = e.target.closest('.faq-q');
    if(faqQ){
      faqQ.closest('.faq-item').classList.toggle('open');
      return;
    }

    var catTab = e.target.closest('.cat-tab');
    if(catTab){
      document.querySelectorAll('.cat-tab').forEach(function(t){ t.classList.remove('active'); });
      catTab.classList.add('active');
      var cat = catTab.dataset.cat;
      document.querySelectorAll('#productGrid .card').forEach(function(card){
        if(cat === 'all' || card.dataset.category === cat){
          card.style.display = '';
        } else {
          card.style.display = 'none';
        }
      });
      return;
    }

    var cardQtyPlus = e.target.closest('.card-qty-plus');
    var cardQtyMinus = e.target.closest('.card-qty-minus');
    if(cardQtyPlus || cardQtyMinus){
      e.preventDefault();
      var stepper = (cardQtyPlus || cardQtyMinus).closest('.card-qty-stepper');
      if(!stepper) return;
      var valEl = stepper.querySelector('.card-qty-val');
      var current = parseInt(valEl ? valEl.textContent : '0', 10) || 0;
      var next = cardQtyPlus ? current + 1 : Math.max(0, current - 1);
      changeCardQty(stepper, next, current);
      return;
    }

    var pkgOpt = e.target.closest('.pkg-option');
    if(pkgOpt){
      document.querySelectorAll('.pkg-option').forEach(function(o){ o.classList.remove('selected'); });
      pkgOpt.classList.add('selected');
      var input = document.getElementById('selectedVariantId');
      if(input) input.value = pkgOpt.dataset.variantId;
      return;
    }

    if(e.target.id === 'qtyMinus' || e.target.id === 'qtyPlus'){
      var span = document.getElementById('qtyVal');
      var qtyInput = document.getElementById('qtyInput');
      var val = parseInt(span.textContent, 10) || 1;
      if(e.target.id === 'qtyMinus' && val > 1) val--;
      if(e.target.id === 'qtyPlus') val++;
      span.textContent = val;
      if(qtyInput) qtyInput.value = val;
      return;
    }

    if(e.target.id === 'tLeft' || e.target.id === 'tRight'){
      var car = document.getElementById('tcarousel');
      if(car) car.scrollBy({ left: e.target.id === 'tLeft' ? 300 : -300, behavior: 'smooth' });
      return;
    }

    var dot = e.target.closest('.tdot');
    if(dot){
      var idx = dot.dataset.idx;
      var targetCard = document.querySelector('.tcarousel [data-idx="' + idx + '"]');
      if(targetCard) targetCard.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      return;
    }

    var cartPlus = e.target.closest('.cart-plus');
    var cartMinus = e.target.closest('.cart-minus');
    var cartRemove = e.target.closest('.remove-btn');
    if(cartPlus || cartMinus || cartRemove){
      e.preventDefault();
      var line = (cartPlus || cartMinus || cartRemove).dataset.line;
      var row = document.querySelector('.cart-item[data-line="' + line + '"]');
      var qtySpan = row ? row.querySelector('.qty-ctrl span') : null;
      var currentQty = qtySpan ? parseInt(qtySpan.textContent, 10) : 1;
      var newQty = currentQty;
      if(cartPlus) newQty = currentQty + 1;
      if(cartMinus) newQty = Math.max(0, currentQty - 1);
      if(cartRemove) newQty = 0;
      if(newQty === 0){
        removeCartLine(line, row);
      } else {
        if(qtySpan) qtySpan.textContent = newQty;
        updateCartLine(line, newQty);
      }
      return;
    }
  });

  function initTestimonialDots(){
    var car = document.getElementById('tcarousel');
    var dots = document.querySelectorAll('.tdot');
    if(!car || !dots.length || !('IntersectionObserver' in window)) return;
    var cards = car.querySelectorAll('[data-idx]');
    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          var idx = entry.target.dataset.idx;
          dots.forEach(function(d){ d.classList.toggle('active', d.dataset.idx === idx); });
        }
      });
    }, { root: car, threshold: 0.6 });
    cards.forEach(function(c){ observer.observe(c); });
  }

  initLanguage();
  setHeaderHeightVar();
  window.addEventListener('resize', setHeaderHeightVar);
  updateCartCount();
  initTestimonialDots();
  syncCardQuantities();
})();
